import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/style.css";
import "./assets/css/dark-style.css";
import "./assets/css/transparent-style.css";
import "./assets/css/skin-modes.css";
import "./assets/css/icons.css";
import "./assets/colors/color1.css";
import "./assets/iconfonts/feather/fonts/feather-webfont.eot?t=1501841394106";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
